import { Component, Inject, OnInit } from "@angular/core";
import { NZ_MODAL_DATA, NzModalRef } from "ng-zorro-antd/modal";
import { DialogService } from "src/app/services/dialog.service";
import { UserAuthenticationServices } from "src/app/services/user-authentication.services";

@Component({
    selector: "app-copy-acess-popup",
    templateUrl: "./copy-acess-popup.component.html",
    styleUrls: ["./copy-acess-popup.component.scss"],
    standalone: false
})
export class CopyAcessPopupComponent implements OnInit {
  userSelected: any;
  usersData: any[] = [];
  userInputFilter: string = "";
  defaultQuery: any;
  /** seleção por id — a lista é recarregada a cada filtro e os objetos mudam */
  selectedUsers: Map<any, any> = new Map();
  loadingDataUsers: boolean = false;
  private filterTimer: any;

  constructor(
    @Inject(NZ_MODAL_DATA) public dialogData,
    public dialogRef: NzModalRef<any>,
    public dialogService: DialogService,
    private UserAuthenticationServices: UserAuthenticationServices
  ) {}

  ngOnInit(): void {
    this.userSelected = this.dialogData;
    this.defaultQuery = " U.IDUSER <> " + this.userSelected.id;
    this.loadUsers(null);
  }

  updateFilterUser() {
    clearTimeout(this.filterTimer);
    this.filterTimer = setTimeout(() => this.loadUsers(this.userInputFilter), 300);
  }

  clearFilter() {
    this.userInputFilter = "";
    this.loadUsers(null);
  }

  loadUsers(filterUser: any) {
    if (filterUser == null || filterUser.length == 0) {
      filterUser = null;
    }

    this.loadingDataUsers = true;
    this.UserAuthenticationServices.getAllUsers(filterUser, this.defaultQuery).then((x) => {
      this.usersData = this.UserAuthenticationServices.usersArr;
      this.loadingDataUsers = false;
    });
  }

  toggleUser(user, checked: boolean) {
    if (checked) {
      this.selectedUsers.set(user.id, user);
    } else {
      this.selectedUsers.delete(user.id);
    }
  }

  finalizar(event: Event) {
    this.dialogRef.close(Array.from(this.selectedUsers.values()));
  }
}
